import React from "react";

const DocumentViewSkeleton: React.FC = () => (
  <div className="flex flex-col md:flex-row bg-slate-50 text-slate-800 font-sans flex-1 overflow-hidden animate-pulse">
    {/* left half */}
    <div className="w-full md:w-1/2 flex flex-col border-r border-slate-200 overflow-hidden">
      {/* toolbar */}
      <div className="bg-[#303a4a] py-1 px-4 flex items-center justify-between gap-2 h-10">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
          <div className="w-40 h-4 bg-slate-600 rounded" />
        </div>
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
        </div>
      </div>

      {/* image area */}
      <div className="flex-grow bg-slate-100 overflow-hidden py-5 px-5 space-y-8">
        {[...Array(2)].map((_, i) => (
          <div key={i}>
            <div className="h-4 bg-slate-300 rounded w-16 mx-auto mb-3" />
            <div className="w-full h-[500px] bg-slate-300 rounded" />
          </div>
        ))}
      </div>
    </div>

    {/* right half */}
    <div className="w-full md:w-1/2 flex flex-col overflow-hidden">
      {/* toolbar */}
      <div className="bg-[#303a4a] py-1 px-4 flex items-center justify-between gap-2 h-10">
        <div className="w-32 h-4 bg-slate-600 rounded" />
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
          <div className="w-7 h-7 bg-slate-600 rounded-md" />
        </div>
      </div>

      {/* tab bar */}
      <div className="border-b border-slate-200 px-4 flex gap-4 bg-white h-10 items-end pb-2">
        <div className="w-20 h-3 bg-slate-200 rounded" />
        <div className="w-20 h-3 bg-slate-200 rounded" />
        <div className="w-16 h-3 bg-slate-200 rounded" />
      </div>

      {/* search bar */}
      <div className="px-4 py-3 border-b border-slate-200 flex gap-2 bg-white">
        <div className="flex-1 h-8 bg-slate-200 rounded" />
        <div className="w-20 h-8 bg-slate-200 rounded" />
      </div>

      {/* extracted data lines */}
      <div className="flex-grow bg-white overflow-hidden p-4 space-y-6">
        {[...Array(3)].map((_, pageIdx) => (
          <div key={pageIdx} className="space-y-2">
            <div className="h-4 bg-slate-200 rounded w-1/4 mb-3" />
            {[...Array(8)].map((_, lineIdx) => (
              <div
                key={lineIdx}
                className="h-3 bg-slate-200 rounded"
                style={{ width: `${65 + ((lineIdx * 13 + pageIdx * 7) % 30)}%` }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default DocumentViewSkeleton;
